import React from 'react'
import './detail-tabs.css'

export type DetailTabItem = {
  id: string
  label: string
}

type Props = {
  tabs: DetailTabItem[]
  activeId: string
  onChange: (id: string) => void
  children?: React.ReactNode
}

/** Underline tabs used inside detail accordions (Activities / Sources). */
export function DetailTabs({ tabs, activeId, onChange, children }: Props) {
  return (
    <div className="detail-tabs">
      <div className="detail-tabs-bar" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={tab.id === activeId}
            className={`detail-tab${tab.id === activeId ? ' is-active' : ''}`}
            onClick={() => onChange(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>
      {children ? <div className="detail-tabs-panel">{children}</div> : null}
    </div>
  )
}
